module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgment"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Part01"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVING INTO THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENCHES")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANKS")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O TO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter01"
    }
  }, [_vm._v("1. April 1918: The Great German Spring Offensive; The Big Red One “Over the Top”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. May 1918: The Red Baron; “Hello Girls”; Cantigny Sector")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. June 1918: Holding Cantigny; Birth of the Devil Dogs")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANKS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE FROM")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFENSE TO")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFENSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. July 1918: Powder River, Let ’Er Buck!; Sowing Seeds of Victory; Rock of the Marne; On to Soissons; Turn of the Tide")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. August 1918: War at Sea; Battle of Montdidier; Aisne-Marne Offensive")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. September 1918: The Naval War; Battle of St. Mihiel; Nurses at War; Native and Black Warriors")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. A W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR TO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN AND AN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LUSIVE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACE TO")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILD")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. October 1918: Grand Meuse—Argonne Offensive; Lost Battalion; Great Influenza Pandemic")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. November 1918: The Armistice—End of the Great War; America Celebrates; Prisoners of War Return")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Postwar Era: Watch on the Rhine—German Occupation; The Peace Conference; Burying the Dead; An Elusive Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0